import { CLEAR_TRAINING } from '../../types';

export const clearTrainingTray = () => async (dispatch) => {
  dispatch({
    type: CLEAR_TRAINING,
    payload: [],
  });
};
